<ng-container *ngIf="!!get">
    <tt-card [ttHeading]="get.page_heading" ttTranslateHeading="false">
        <tt-tabs *ngIf="get.argtype === 'custact_no'" [(ttSelectedId)]="get.gb_orderheads_related" (ttSelectedIdChange)="getChange.emit(get)">
            <tt-tab ttId="orderheads_custact_related" ttLabel="orderheads_custact_related"></tt-tab>
            <tt-tab ttId="orderheads_customer_related" ttLabel="orderheads_customer_related"></tt-tab>
        </tt-tabs>
        <tt-select
            *ngIf="companies.length > 2"
            ttLabel="businessco"
            [(ttModel)]="get.businessco_no"
            (ttModelChange)="onBusinessCoChanged()"
            [ttData]="companies"
            ttDataId="businessco_no"
            ttDataName="company_name"
            [ttShowClearButton]="get.businessco_no !== '99999'"
            ttClearValue="99999"
        ></tt-select>
        <form (submit)="$event.preventDefault(); getChange.emit(get)">
            <tt-input
                [ttRememberId]="'orderheads/' + get.argtype + '/' + get.argvalue + '.ordersearch'"
                ttLabel="ordersearch"
                [(ttModel)]="get.ordersearch"
                (ttModelChange)="$event === '' && getChange.emit(get)"
                ttShowClearButton
            >
                <tt-form-field-button buttons ttIcon="fas fa-search" ttType="primary" (ttClick)="getChange.emit(get)"></tt-form-field-button>
            </tt-input>
        </form>
        <tt-input *ngIf="get.argtype === 'cust_no' || +get.cust_no > 0" ttLabel="cust_no_and_name" [(ttModel)]="get.cust_no_and_name" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="customersmenu" [ttGotoParms]="get.cust_no"></tt-form-field-button>
        </tt-input>
        <tt-input *ngIf="+get.cust_no > 0" ttLabel="cust_no" [(ttModel)]="get.cust_no" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="customersmenu" [ttGotoParms]="get.cust_no"></tt-form-field-button>
        </tt-input>
        <tt-select
            ttLabel="ordertype"
            [(ttModel)]="get.ordertype_id"
            (ttModelChange)="getChange.emit(get)"
            [ttData]="orderTypes"
            ttDataId="ordertype_id"
            ttDataName="ordertype_name"
            [ttShowClearButton]="get.ordertype_id !== 'All'"
            ttClearValue="All"
        ></tt-select>
        <tt-select
            ttLabel="orderstatus"
            [(ttModel)]="get.orderstatus_id"
            (ttModelChange)="getChange.emit(get)"
            [ttData]="orderStatuses"
            ttDataId="orderstatus_id"
            ttDataName="orderstatus_name"
            [ttShowClearButton]="get.orderstatus_id > '0'"
        ></tt-select>
        <tt-select
            *ngIf="get.show_gb_regby === '1'"
            ttLabel="reg_by_portal_user_name"
            [(ttModel)]="get.reg_by_portal_user_keyno"
            (ttModelChange)="getChange.emit(get)"
            [ttData]="portalUsers"
            ttDataId="item_id"
            ttDataName="item_name"
            [ttShowClearButton]="'' + get.reg_by_portal_user_keyno > '0'"
        >
            <tt-form-field-button buttons ttIcon="fas fa-user" ttType="success" (ttClick)="get.reg_by_portal_user_keyno = get.current_portal_user_keyno; getChange.emit(get)"></tt-form-field-button>
        </tt-select>
        <tt-select
            *ngIf="get.show_seller_id === '1'"
            ttLabel="seller"
            [(ttModel)]="get.seller_id"
            (ttModelChange)="getChange.emit(get)"
            [ttData]="sellers"
            ttDataId="item_id"
            ttDataName="item_name"
            [ttShowClearButton]="get.seller_id > '0'"
        ></tt-select>
        <tt-date-range
            [ttRememberId]="'orderheads/' + get.argtype + '/' + get.argvalue"
            *ngIf="get.show_dateselector === '1'"
            [ttLabel]="get.search_confirmed_deliverydate === '1' ? 'search_confirmed_deliverydate_fomtom' : 'orderdate_fom_tom'"
            [(ttStartDate)]="get.date_fom"
            [(ttEndDate)]="get.date_tom"
            [(ttInterval)]="get.dateselector_index"
            (ttModelChange)="getChange.emit(get)"
        ></tt-date-range>
        <tt-button-goto
            *ngIf="get.show_new_order_button === '1'"
            ttText="create_new_orderhead"
            ttIcon="far fa-plus"
            ttGoto="orderheadcreate"
            [ttGotoParms]="{ argtype: get.argtype, argvalue: get.argvalue, ordertype_id: '0' }"
        ></tt-button-goto>
    </tt-card>
</ng-container>
